import { useState, useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, Button, useModal } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'
import BuyNowModal from './BuyNowModal'

import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledDigit = styled(Text)`
  width: 40px;
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: #141e31;
  border-radius: 6px;
  padding: 12px 14px;
`

const StyledSeparator = styled(Text)`
  self-align: center;
  self-justify: center;
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 8px;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const Timer = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'
  const { account } = useWeb3React()

  const [currentCycle, setCurrentCycle] = useState(0)
  const [endTimeCurrentCycle, setEndTimeCurrentCycle] = useState(0)
  const [ticketPrice, setTicketPrice] = useState(0)
  const [currentTimestamp, setCurrentTimestamp] = useState(0)

  const [hoursL, setHoursL] = useState(0)
  const [hoursR, setHoursR] = useState(0)
  const [minutesL, setMinutesL] = useState(0)
  const [minutesR, setMinutesR] = useState(0)
  const [secondsL, setSecondsL] = useState(0)
  const [secondsR, setSecondsR] = useState(0)

  const [onBuyNow] = useModal(<BuyNowModal />)

  useEffect(() => {
    genericprovider.getBlockNumber().then((blockNumber) => {
      genericprovider.getBlock(blockNumber).then((block) => {
        setCurrentTimestamp(block.timestamp)
      })
    })
  }, [])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, abi, genericprovider)
    contract.functions.ticketPrice().then((ticketPriceResp) => {
      setTicketPrice(+ethers.utils.formatUnits(ticketPriceResp[0]))
    })
  }, [])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, abi, genericprovider)
    contract.functions.currentCycle().then((currentCycleResp) => {
      setCurrentCycle(currentCycleResp[0].toNumber())
    })
  }, [])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, abi, genericprovider)
    contract.functions.getEndTimeCurrentCycle().then((endTimeCurrentCycleResp) => {
      console.log(endTimeCurrentCycleResp[0].toNumber())
      setEndTimeCurrentCycle(endTimeCurrentCycleResp[0].toNumber())
    })
    // setEndTimeCurrentCycle(new Date().getTime() / 100 + 60 * 60 * 24 * 2)
  }, [])

  useEffect(() => {
    console.log(endTimeCurrentCycle, currentTimestamp, endTimeCurrentCycle - currentTimestamp)
    if (currentTimestamp === 0) return
    if (endTimeCurrentCycle === 0) return
    if (currentTimestamp > endTimeCurrentCycle) return
    const end = new Date().getTime() + (endTimeCurrentCycle - currentTimestamp) * 1000
    setInterval(() => {
      const timeLeft = end - new Date().getTime()
      if (timeLeft < 0) {
        setHoursL(0)
        setHoursR(0)
        setMinutesL(0)
        setMinutesR(0)
        setSecondsL(0)
        setSecondsR(0)
        setCurrentTimestamp(0)
        return
      }
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      if (hours < 10) {
        setHoursL(0)
        setHoursR(hours)
      } else {
        setHoursL(Math.floor(hours / 10))
        setHoursR(hours % 10)
      }
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
      if (minutes < 10) {
        setMinutesL(0)
        setMinutesR(minutes)
      } else {
        setMinutesL(Math.floor(minutes / 10))
        setMinutesR(minutes % 10)
      }
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)
      if (seconds < 10) {
        setSecondsL(0)
        setSecondsR(seconds)
      } else {
        setSecondsL(Math.floor(seconds / 10))
        setSecondsR(seconds % 10)
      }
    }, 1000)
  }, [endTimeCurrentCycle, currentTimestamp])

  return (
    <StyledCard style={{ flexDirection: 'column', paddingTop: 40 }}>
      <StyledSoftText>Time left to join draw {currentCycle ? `#${currentCycle}` : ''}</StyledSoftText>
      <Flex style={{ marginTop: 8 }}>
        <Flex style={{ flexDirection: 'column', alignItems: 'center' }}>
          <Flex style={{ alignItems: 'center', gap: 4 }}>
            <StyledDigit>{hoursL}</StyledDigit>
            <StyledDigit>{hoursR}</StyledDigit>
          </Flex>
          <StyledSoftText>Hours</StyledSoftText>
        </Flex>
        <StyledSeparator>:</StyledSeparator>
        <Flex style={{ flexDirection: 'column', alignItems: 'center' }}>
          <Flex style={{ alignItems: 'center', gap: 4 }}>
            <StyledDigit>{minutesL}</StyledDigit>
            <StyledDigit>{minutesR}</StyledDigit>
          </Flex>
          <StyledSoftText>Minutes</StyledSoftText>
        </Flex>
        <StyledSeparator>:</StyledSeparator>
        <Flex style={{ flexDirection: 'column', alignItems: 'center' }}>
          <Flex style={{ alignItems: 'center', gap: 4 }}>
            <StyledDigit>{secondsL}</StyledDigit>
            <StyledDigit>{secondsR}</StyledDigit>
          </Flex>
          <StyledSoftText>Seconds</StyledSoftText>
        </Flex>
      </Flex>
      {account ? (
        <Button
          onClick={onBuyNow}
          style={{ marginTop: 16, width: '200px', borderRadius: 16 }}
          disabled={currentTimestamp === 0 || currentTimestamp > endTimeCurrentCycle}
        >
          Play Now!
        </Button>
      ) : (
        <ConnectWalletButton style={{ marginTop: 16, width: '200px', borderRadius: 16 }}>
          Connect Wallet
        </ConnectWalletButton>
      )}
      <StyledSoftText style={{ marginTop: 8, marginBottom: 20 }}>Ticket Price: {ticketPrice} USDT</StyledSoftText>
    </StyledCard>
  )
}

export default Timer
